import React, { Suspense } from 'react';
import { View } from '../types';
import { LegacyViewRenderer } from './LegacyViewRenderer';
import { moduleRegistry } from '../modules.registry';
import ErrorBoundary from '../components/layout/ErrorBoundary';
import { ModuleRouteGuard } from '../core/routing';

interface AppRouterProps {
currentView: View | 'admin';
}

export function AppRouter({ currentView }: AppRouterProps) {
	const registeredRoute = moduleRegistry.findRouteByLegacyView(String(currentView));
	if (registeredRoute) {
		return (
			<ErrorBoundary>
				<Suspense
					fallback={
						<div className="flex min-h-[240px] items-center justify-center text-sm text-slate-500">
							Carregando módulo...
						</div>
					}
				>
					<ModuleRouteGuard manifest={registeredRoute.manifest}>
						{registeredRoute.route.render(String(currentView))}
					</ModuleRouteGuard>
				</Suspense>
			</ErrorBoundary>
		);
	}

	return <LegacyViewRenderer currentView={currentView} />;
}
